export const VatTypeEnum = Object.freeze({ VATZ: 'VATZ', VATS: 'VATS' });

export const VATMessageEnum = Object.freeze({
  CustomsMOP: 'Customs MoP',
  NotAvailable: 'N/A',
  NULL: '',
  PVA: 'PVA',
});

// Helper function to map numeric or string VAT code to enum value
export const getVatEnumValue = (vatCode) => {
  switch (vatCode) {
    case 1:
    case 'VATZ':
      return VatTypeEnum.VATZ;
    case 2:
    case 'VATS':
      return VatTypeEnum.VATS;
    default:
      return null;
  }
};

export const ImportType = Object.freeze({
  SDI: 'SDI',
  SFD: 'SFD',
});
